<template>
  <router-link :to="{ name: 'notification-list' }">
    <div class="notificacion" title="Notificaciones del sistema">
      <a href="#">
        <div
          style="
            display: block;
            margin-right: 10px;
            width: 40px;
            height: 35px;
            cursor: pointer;
          "
        >
          <span class="fa-layers fa-fw" style="margin-top: 15px">
            <i class="far fa-bell"></i>
            <span
              id="badge"
              class="fa-layers-counter"
              v-if="v_notificationBadge > 0"
              >{{ v_notificationBadge }}</span
            >
          </span>
        </div>
      </a>
    </div>
  </router-link>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Notifications",
  data() {
    return {};
  },
  computed: {
    ...mapState("notification", ["v_notificationBadge"]),
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.notificacion {
  margin-top: -5px;
  height: 40px;
  color: #72777a;
}

.capsule {
  margin-right: 20px;
}

.notificacion a {
  color: #72777a;
}

.notificacion a:hover {
  color: #404446;
  background:#e01024
}

.fa-layers-counter {
  -webkit-transform: scale(0.5) !important;
  transform: scale(0.6) translateX(50%) translateY(-50%) !important;
  font-weight: bold;
  background: #ff253a;
  cursor: pointer !important;
}

/*Change two backgrounds at the same time*/
.notificacion a:hover + .fa-layers-counter {
  background: #e01024 !important;
}
</style>
